$(".custom-featured-products-grid_slider").slick({
  dots: false,
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow: false,
  nextArrow: false,
  swipe: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});
/*$(".custom-collections-grid_slider").slick({
  dots: false,
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: false,
  nextArrow: false,
  swipe: true,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});*/

const collectionsObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    requestAnimationFrame(() => {
      $(entry.target).slick({
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: false,
        nextArrow: false,
        swipe: true,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: false,
            },
          },
        ],
      });
    });
    observer.unobserve(entry.target);
  });
}, { rootMargin: '200px' });

document.querySelectorAll('.custom-collections-grid_slider').forEach(slider => {
  collectionsObserver.observe(slider);
});


if (!window.location.pathname.includes('/pages/shop-the-look')) {
/*$(".custom-collections-grid_sliders").slick({
  dots: false,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: false,
  nextArrow: false,
  swipe: true,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});*/
const collectionsPluralObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    requestAnimationFrame(() => {
      $(entry.target).slick({
        dots: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: false,
        nextArrow: false,
        swipe: true,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
            },
          },
        ],
      });
    });
    observer.unobserve(entry.target);
  });
}, { rootMargin: '200px' });

document.querySelectorAll('.custom-collections-grid_sliders').forEach(slider => {
  collectionsPluralObserver.observe(slider);
});
}
$(".custom_you_may_also_like_slider").slick({
  dots: false,
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: false,
  nextArrow: false,
  swipe: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});
$(".custom-tranding_list_slider").slick({
  dots: false,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: false,
  nextArrow: false,
  swipe: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});
$(".shop_the_look-items_slider").slick({
  dots: false,
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  prevArrow: false,
  nextArrow: false,
  swipe: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
      },
    },
  ],
});


$(document).ready(function () {
function updateSliderButtons($wrapper, slick, currentSlide) {

  let $prevBtn = $wrapper.find(".slider-nav .prev").first();
  let $nextBtn = $wrapper.find(".slider-nav .next").first();

  let slidesToShow = slick.options.slidesToShow || 1;
  let lastSlideIndex = slick.slideCount - slidesToShow;

  if (currentSlide <= 0) {
    $prevBtn.addClass("disabled");
  } else {
    $prevBtn.removeClass("disabled");
  }

  if (currentSlide >= lastSlideIndex) {
    $nextBtn.addClass("disabled");
  } else {
    $nextBtn.removeClass("disabled");
  }
}

$("[data-slider]").each(function () {

  let $slider = $(this);

  if ($slider.closest(".product_featured_slider").length) return;

  let $wrapper = $slider.closest(
    ".shop_the_look-wrapper-popup, .custom-featured_container, .shop_the_look-wrapper-main"
  );

  if (!$wrapper.length) return;

  $slider.on("init reInit afterChange", function (
    event,
    slick,
    currentSlide
  ) {
    updateSliderButtons($wrapper, slick, currentSlide || 0);
  });

});
$(document).on("click", ".slider-nav .prev", function () {
  let $wrapper = $(this).closest(
    ".shop_the_look-wrapper-popup, .custom-featured_container, .shop_the_look-wrapper-main"
  );

  let $slider = $wrapper.find("[data-slider]").first();

  if (!$slider.length || $(this).hasClass("disabled")) return;

  $slider.slick("slickPrev");

});

$(document).on("click", ".slider-nav .next", function () {
  let $wrapper = $(this).closest(
    ".shop_the_look-wrapper-popup, .custom-featured_container, .shop_the_look-wrapper-main"
  );

  let $slider = $wrapper.find("[data-slider]").first();

  if (!$slider.length || $(this).hasClass("disabled")) return;

  $slider.slick("slickNext");

});
});

/*$(".product_featured_for_slider").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 1,
  swipe: true,
  prevArrow:
    "<button class='a-left control-c prev slick-prev'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/prev.svg?v=1707290984'></button>",
  nextArrow:
    "<button class='a-right control-c next slick-next'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/next.svg?v=1707290984'></button>",
});*/
const sliderObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    requestAnimationFrame(() => {
      $(entry.target).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        swipe: true,
        prevArrow: "<button class='a-left control-c prev slick-prev'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/prev.svg?v=1707290984'></button>",
        nextArrow: "<button class='a-right control-c next slick-next'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/next.svg?v=1707290984'></button>",
      });
    });
    observer.unobserve(entry.target);
  });
}, { rootMargin: '200px' });

document.querySelectorAll('.product_featured_for_slider').forEach(slider => {
  sliderObserver.observe(slider);
});
if (jQuery(window).width() < 768) {
  jQuery(".main-product-custom .the-grid").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      "<button class='a-left control-c prev slick-prev'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/prev.svg?v=1707290984'></button>",
    nextArrow:
      "<button class='a-right control-c next slick-next'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/next.svg?v=1707290984'></button>",
    arrows: true,
    dots: false,
  });
  $(".footer-block_grid__item_link_list .footer-block__heading").click(
    function () {
      $(this)
        .next()
        .slideToggle()
        .parent()
        .toggleClass("opendrop")
        .siblings(".footer-block_grid__item_link_list")
        .removeClass("opendrop")
        .find(".footer-block__heading")
        .next()
        .slideUp();
    }
  );
}
if ($(window).width() > 1023) {
$(".theImageContainer:not(.video_tag)").zoom({
  magnify: 0.28,
});
}

$(document).ready(function () {
  setInterval(function () {
    let v = window.location.hash;
    if (v != "") {
      $(`.tabtrigger a[href="${v}"]`).trigger("click");
    } else {
      $(`.tabtrigger:first-child a`).trigger("click");
    }
  }, 1000);
});
$(".tabtrigger>a").click(function () {
  let v = $(this).attr("data-tab");
  $(this)
    .addClass("active_tab")
    .parents(".container")
    .find(".right-side_wrapper")
    .find(`.right-side_tabs[data-tab="${v}"]`)
    .show()
    .siblings()
    .hide();
  $(this).parent().siblings().find("a").removeClass("active_tab");
});
$(".custom_accordions .accordion_trigger").click(function () {
  $(this)
    .toggleClass("active_accordion")
    .next()
    .slideToggle()
    .parent(".custom_accordions")
    .siblings(".custom_accordions")
    .find(".accordion_trigger")
    .removeClass("active_accordion")
    .next()
    .slideUp();
});



$('#show-popup-btn').click(function() {
    $('.size-guide-popup-main .modal').fadeIn();
})
  $('.size-guide-popup-main .close-btn').click(function() {
    $('.size-guide-popup-main .modal').fadeOut();
})
$('#show-popup-btnring').click(function() {
    $('.ring-size-popup-main .modal').fadeIn();
})
$('.ring-size-popup-main .close-btn').click(function() {
$('.ring-size-popup-main .modal').fadeOut();
})



document.addEventListener("DOMContentLoaded", function () {
  function getTargetGridItem(customItem) {
    let targetItem = customItem.previousElementSibling;

    // First check previous product grid item
    while (targetItem) {
      if (
        targetItem.classList.contains("grid__item") &&
        !targetItem.classList.contains("collection-custom-image")
      ) {
        return targetItem;
      }

      targetItem = targetItem.previousElementSibling;
    }

    // If previous not found, check next product grid item
    targetItem = customItem.nextElementSibling;

    while (targetItem) {
      if (
        targetItem.classList.contains("grid__item") &&
        !targetItem.classList.contains("collection-custom-image")
      ) {
        return targetItem;
      }

      targetItem = targetItem.nextElementSibling;
    }

    return null;
  }

  function setCustomImageHeight() {
    document
      .querySelectorAll(".grid__item.collection-custom-image")
      .forEach(function (customItem) {
        const targetItem = getTargetGridItem(customItem);

        if (!targetItem) return;

        customItem.style.height = targetItem.offsetHeight + "px";
      });
  }

  setCustomImageHeight();

  window.addEventListener("load", setCustomImageHeight);
  window.addEventListener("resize", setCustomImageHeight);

  setTimeout(setCustomImageHeight, 300);
  setTimeout(setCustomImageHeight, 800);
});

document.addEventListener("DOMContentLoaded", function () {
 document.querySelectorAll(".custom_view_all_link").forEach(link => {
  link.addEventListener("click", function () {
   const sectionId = $(this)
  .closest('[id^="shopify-section-"]')
  .attr('id');

localStorage.setItem('shop_the_look_section_id', sectionId);
  });
});
});